






























import { Component, Vue, Prop } from "vue-property-decorator";
import { State } from "vuex-class";
import { Profile } from "@foxone/api/src/models/hfox";
import { Profile as AccountProfile } from "@foxone/api/src/models/account";

@Component
class WalletSelector extends Vue {
  @State(state => state.hfox.profile) profile!: Profile;

  @State(state => state.basis.account.profile) accountProfile!: AccountProfile;

  @Prop() wallet!: string;

  get meta() {
    const account = this.profile.account;
    const attrs = {
      foxone: {
        label: "Fox.ONE",
        icon: require("@/assets/images/icon_fox.png"),
        width: 16,
        color: "#EF8343"
      },
      mixin: {
        label: "Mixin",
        icon: require("@/assets/images/icon_mixin.png"),
        width: 18,
        color: "#37C3FF"
      }
    };
    let wallets = Object.keys(account).map(key => ({
      value: key,
      ...attrs[key],
      ...account[key]
    }));
    const foxonePinSet = this.accountProfile?.foxone?.is_pin_set ?? false;

    const foxoneMigrateRequired =
      this.accountProfile?.foxone_migrate_required ?? false;
    if (!foxonePinSet || foxoneMigrateRequired) {
      wallets = wallets.filter(wallet => wallet.value !== "foxone");
    }
    return {
      wallets
    };
  }

  handleSelect(value) {
    this.$emit("change", value);
  }
}
export default WalletSelector;
